import { Component, Input } from '@angular/core'
import { environment } from '@nx-superprep/environment';


@Component({
  selector: 'nx-superprep-version',
  standalone: true,
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss'],
})
export class VersionComponent {
  @Input() showLtVersion = false;
  get version() { return environment.config.version }
  get suffix() { return (environment.config.environment as string)[0]??'' }
  get ltVersion() { return environment.config.ltVersion?.['superprep-gameplays-react'] }
}
